import { render, staticRenderFns } from "./PopupFiltersProjects.vue?vue&type=template&id=6e1bcf04"
import script from "./PopupFiltersProjects.vue?vue&type=script&lang=ts"
export * from "./PopupFiltersProjects.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports